import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from "react";
const Feed =  React.lazy(() => import('../page/Feed'));

const routes: AppRouteType[] = [
  {
    path: slugs.feed,
    component: Feed,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
